module.exports = __webpack_public_path__ + "img/07zscq.750b9d1a.svg";